import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import { prepareReviews } from '../../mappers/prepareReviews';
import {
  fetchGetReviews,
  TGetReviewsRequest,
  TGetReviewsResponse,
} from '../../repositories/newbuilding-reviews/v1/get-reviews';

export interface IFetchReviewsParams {
  httpApi: IHttpApi;
  parameters: TGetReviewsRequest;
}

export async function fetchReviews({ httpApi, parameters }: IFetchReviewsParams) {
  const result: TGetReviewsResponse = await fetchGetReviews({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchReviews',
      message: result.response.message as string,
    });
  }

  return prepareReviews(result.response);
}
